import {success, invalid} from "./helpers";
import {
  REGISTER
} from "../actions/CreateClientAccount";

const initialState = {
  ifRegisterSuccess: false,
  error_message: ''
}

const create_client_account = (state=initialState, action) => {
  switch(action.type) {
    case success(REGISTER):
      return {
        ...state,
        ifRegisterSuccess: true,
        error_message: ''
      }
    case invalid(REGISTER):
      return {
        ...state,
        ifRegisterSuccess: false,
        error_message: action.payload.message
      }
    default:
      return state
  }
}

export default {
  create_client_account
}


// WEBPACK FOOTER //
// ./src/reducers/createClientAccount.js